import { HIDROTEST_UYARI_KALIPLARI } from "./hidrotest.js";
import { NDT_UYARI_KALIPLARI } from "./ndt-raporu.js";
import { yenisiGeldiTarihEtkisi } from "./kutuk-belge.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). Kütük türü `kalibrasyon` ile karışmasın diye ayrı ad. */
export const KALIBRASYON_BELGE_TURU = "alet_kalibrasyon";
/** Okunan Documents türü (GELEN_TURLERI anahtarı, "Calibration certificate"; Registers grubu, kütük sınıfı). */
export const KALIBRASYON_GELEN_TURU = "kutuk:alet:kalibrasyon";
export const kalibrasyonGelenTuruMu = (t) => t === KALIBRASYON_GELEN_TURU;
/** Olay kaydında nesne tipi (nesneId = kalibrasyon_kaydi.id). */
export const KALIBRASYON_OLAY_NESNESI = "kalibrasyon_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const KALIBRASYON_GIRDI_AILESI = "Calibration-certificate-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const KALIBRASYON_EXCEL_ADI = "Calibration certificate";
/** Bir dosyada en çok cihaz (`Device`). */
export const KALIBRASYON_CIHAZ_EN_COK = 20;
/** M1-15: çok cihazlı okunmuş dosyada formun Pages'i Record'daki aletin cihazlarından birinin aralığı değilse dosyalama kapısının cümlesi (409). */
export const KALIBRASYON_SAYFA_METNI = "Pages do not match a device of this instrument. Use the pages of the device on this instrument (“Use these pages”), or leave Pages empty.";
/** Okuma işi kodu ("CAL-5A1B2C3D"); "KAL-" uyarı kodlarından ve kütük türü `kalibrasyon`'dan ayrı. */
export const kalibrasyonKodu = (kayitId) => `CAL-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/**
 * Cihaz düzeyi alanlar (ROWS, cihaz başına 11; sabit sıra; sözleşme §9.3, sürüm 1). Her alanın tüketicisi sözleşmede yazılıdır. `etiket` hem ekran metni hem ROWS'taki
 * Field adıdır. Kimlik değeri yalnız sertifika no'dur. DOCUMENT'te değer alanı yoktur (yalnız künye).
 */
export const KALIBRASYON_CIHAZ_ALANLARI = [
    { alan: "belge_cinsi", etiket: "Document kind", kimlik: false }, { alan: "sertifika_no", etiket: "Certificate number", kimlik: true },
    { alan: "laboratuvar", etiket: "Laboratory", kimlik: false }, { alan: "akreditasyon", etiket: "Accreditation", kimlik: false },
    { alan: "kalibrasyon_tarihi", etiket: "Calibration date", kimlik: false }, { alan: "bitis", etiket: "Due date", kimlik: false },
    { alan: "seri_no", etiket: "Serial number", kimlik: false }, { alan: "cihaz_kodu", etiket: "Instrument code", kimlik: false },
    { alan: "aralik", etiket: "Calibrated range", kimlik: false }, { alan: "uygunluk", etiket: "Conformity", kimlik: false },
    { alan: "not", etiket: "Remark", kimlik: false },
];
/** Alanın ekran adı; bilinmiyorsa alanın kendisi. */
export const kalibrasyonEtiketi = (alan) => KALIBRASYON_CIHAZ_ALANLARI.find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır; `Device` cihazın sırası, `Pages` cihazın sayfa aralığı). */
export const KALIBRASYON_SATIR_BASLIKLARI = ["Device", "Pages", "Field", "Value", "As written", "Page", "Certainty"];
/** `Document kind` hücresinin değerleri (yalnız bunlar ya da boş). */
export const KALIBRASYON_CINSLERI = {
    kalibrasyon: "Calibration certificate", uygunluk: "Attestation of conformity", uretici: "Manufacturer test report", basinc: "Pressure test certificate", diger: "Other",
};
/** `Conformity` hücresinin değerleri (yalnız bunlar ya da boş). */
export const UYGUNLUK_DEGERLERI = ["Pass", "Fail", "Limited"];
/** Kişinin "Add to Registers" onayının alanı (`belge_deger_onayi.alan`; cihazın parçasında, cihaz başına bir kez). */
export const CIHAZ_EKLEME_ALANI = "kutuk_satiri";
/* ---------------- değer biçimleri (yalnız kesin değerler kullanılır) ---------------- */
/** `Document kind` yazısı → cins (KALIBRASYON_CINSLERI değerleriyle tam eşleşme, büyük-küçük harfe duyarsız); öteki her yazım ve boş değer null. */
export function kalibrasyonCinsiOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    if (!s)
        return null;
    return Object.keys(KALIBRASYON_CINSLERI).find((k) => KALIBRASYON_CINSLERI[k].toLowerCase() === s) ?? null;
}
/** `Conformity` yazısı → değer (büyük-küçük harfe duyarsız); öteki her yazım null. */
export function uygunlukOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    return UYGUNLUK_DEGERLERI.find((x) => x.toLowerCase() === s) ?? null;
}
/** Basınç birimlerinin psi katsayısı (fiziksel sabitler; 1 MPa = 145.0377 psi, hidrotest sözleşmesi §2.2 ile aynı). */
const BIRIM_PSI = { psi: 1, psig: 1, bar: 14.50377, barg: 14.50377, "bar(g)": 14.50377, mpa: 145.0377, kpa: 0.1450377 };
const ARALIK = /^(-?\d+(?:\.\d+)?)\s*-\s*(-?\d+(?:\.\d+)?)\s+(\S.{0,19})$/;
/** `Calibrated range` yazısı ("0-1000 bar") → aralık; biçim dışı ya da alt ucu üst ucundan büyükse null. Birim büyük-küçük harfe duyarsız çevrilir. */
export function kalibrasyonAraligiOku(v) {
    const s = (v ?? "").trim();
    const m = ARALIK.exec(s);
    if (!m)
        return null;
    const alt = Number(m[1]);
    const ust = Number(m[2]);
    if (!(alt <= ust))
        return null;
    const birim = m[3].trim();
    const k = BIRIM_PSI[birim.toLowerCase()];
    return { alt, ust, birim, ustPsi: k === undefined ? null : ust * k, yazildigi: s };
}
/**
 * M1-18: yeni bir kalibrasyon sertifikası eklenirse D-049 kuralı aletin Calibration end'ini ne yapar. Sunucudaki `tarihKurali` ile aynı hesap (`yenisiGeldiTarihEtkisi`);
 * yeni satır aynı tarihli satırların en yenisidir (yükleme zamanı en son).
 */
export function kalibrasyonTarihEtkisi(kayit, yeni) {
    return yenisiGeldiTarihEtkisi("alet", kayit.kalibrasyonSonu, kayit.belgeler, {
        id: "yeni", tur: "kalibrasyon", tarih: yeni.tarih, gecerlilikSonu: yeni.gecerlilikSonu, ts: "9999-12-31T00:00:00.000Z",
    }, false);
}
/* ---------------- uyarılar ---------------- */
/** Kartta üretilen kodlar (üretim sırası: kırmızı, sarı, gri). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). KAL-08 hidrotest karşılaştırmasında üretilir. */
export const KALIBRASYON_UYARI_KODLARI = ["KAL-01", "KAL-02", "KAL-10", "GEN-02", "KAL-06", "KAL-09", "KAL-07", "GEN-04", "GEN-12", "GEN-09"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). GEN-02 ve GEN-09 öteki okuyucularınkiyle aynıdır. */
export const KALIBRASYON_UYARI_KALIPLARI = {
    "KAL-01": "Instrument not in Registers: {0}. Add a new instrument?",
    "KAL-02": "Serial number differs from the register: {0} / {1}.",
    "KAL-10": "Not a calibration certificate. File as instrument reference.",
    "GEN-02": HIDROTEST_UYARI_KALIPLARI["GEN-02"],
    "KAL-06": "Calibration remark: {0}.",
    "KAL-09": "Same instrument calibrated twice on {0}.",
    "KAL-07": "Manufacturer certificate, not an accredited calibration.",
    "GEN-04": "This is a {0}. It belongs to {1}.",
    "GEN-12": "Older than the filed calibration certificate of {0}. The register date stays.",
    "GEN-09": NDT_UYARI_KALIPLARI["GEN-09"],
};
/** KAL-08 (hidrotest karşılaştırmasında): eşleşen aletin okunmuş kalibrasyon aralığı test basıncını kapsamıyor. */
export const KAL08_KALIBI = "Calibrated range {0} does not cover the test pressure {1}.";
//# sourceMappingURL=kalibrasyon.js.map